import EventsPage from './EventsPage'

export default EventsPage
// eslint-disable-next-line import/export
export * from './EventsPage'
